export default "__VITE_ASSET__a35e2b72__"